import { CloseOutlined, TagOutlined, UserOutlined } from "@ant-design/icons";
import { Spin, Breadcrumb, Typography, Row, Col, Divider, Descriptions, Progress, Popconfirm, Button, Space } from "antd";
import { deleteDoc, doc } from "firebase/firestore";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, Link as Direction, useNavigate } from "react-router-dom";
import { db } from "../../firebase/config";
import { Notification } from "../Notification";
import PriceDetailsTable from "./PriceDetailsTable";

const { Text, Link } = Typography;

export default function PriceDetailsPage() {
   //data
   const [priceData, setPriceData] = useState(null);
   const [loadingData, setLoadingData] = useState(true);

   //use location to get the state for the link
   const location = useLocation();

   //useNavigate for redirection
   const navigate = useNavigate();

   useEffect(() => {
      setLoadingData(true);
      setPriceData(location.state);
      setLoadingData(false);
      console.log(priceData);
   }, [location, priceData]);

   const col = { backgroundColor: "white", padding: "20px", height: "100%" };

   if (loadingData) {
      return <Spin />;
   }

   //deletes the Price
   const deleteClient = async (e) => {
      e.preventDefault();
      const ref = doc(db, "priceCalculation", priceData.id);
      try {
         deleteDoc(ref).then(() => {
            Notification("warning", "Deleted!", "Price has been removed");
            navigate("/saved-prices");
         });
      } catch (err) {
         Notification("error", "Login Error", err.message);
      }
   };

   return (
      <>
         <Breadcrumb>
            <Breadcrumb.Item>
               <Text>
                  <Direction to="/saved-prices">Approved</Direction>
               </Text>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
               <Text>{priceData.product.productName}</Text>
            </Breadcrumb.Item>
         </Breadcrumb>
         <Row gutter={[10, 10]} style={{ padding: "18px" }}>
            {/* CLIENT */}
            <Col span={6}>
               <div style={col}>
                  <Row justify="space-between" align="middle">
                     <Col span={24}>
                        <Text style={{ fontSize: "12px", color: "gray" }}>Client</Text>
                     </Col>
                     <Col>
                        <Text style={{ fontSize: "18px" }}>{priceData.client}</Text>
                     </Col>
                     <Col>
                        <UserOutlined style={{ fontSize: "20px" }} />
                     </Col>
                     <Divider />
                     {/* PRODUCT */}
                     <Col span={24}>
                        <Text style={{ fontSize: "12px", color: "gray" }}>Product</Text>
                     </Col>
                     <Col>
                        <Text style={{ fontSize: "18px" }}>{priceData.product.productName}</Text>
                     </Col>
                     <Col>
                        <TagOutlined style={{ fontSize: "18px" }} />
                     </Col>
                     <Divider />
                     <Col span={24}>
                        <Text style={{ fontSize: "12px", color: "gray" }}>Product Link</Text>
                     </Col>
                     <Col>
                        <Link target="_blank" href={priceData.product.productFileUrl}>
                           View file
                        </Link>
                     </Col>
                     <Divider />
                     <Popconfirm title="Are you sure？" onConfirm={deleteClient} okText="Yes" cancelText="No">
                        <Button block danger>
                           <CloseOutlined />
                           delete this price
                        </Button>
                     </Popconfirm>
                  </Row>
               </div>
            </Col>
            <Col span={6}>
               <div style={col}>
                  <Descriptions size="small" contentStyle={{ color: "gray" }} column={1} title="Details">
                     <Descriptions.Item label="Width">{priceData.labelWidth}</Descriptions.Item>
                     <Descriptions.Item label="Height">{priceData.labelHeight}</Descriptions.Item>
                     <Descriptions.Item label="Machine">{priceData.machine}</Descriptions.Item>
                     <Descriptions.Item label="Material">{priceData.material}</Descriptions.Item>
                     <Descriptions.Item label="Created">{moment.unix(priceData.date.created.seconds).format("L")}</Descriptions.Item>
                     <Descriptions.Item label="Knife">{priceData.knifeCode}</Descriptions.Item>
                     <Descriptions.Item label="Label Count">{priceData.labelCount}</Descriptions.Item>
                     <Descriptions.Item label="Extra Profit">{priceData.advanced.extraProfit && priceData.advanced.extraProfit} %</Descriptions.Item>
                     <Descriptions.Item label="Price">
                        {priceData.advanced.fixedPrice ? (
                           <>
                              <Space>
                                 {priceData.totalFixedPrice}
                                 <Text code italic type="danger">
                                    Fixed from {priceData.price}
                                 </Text>
                              </Space>
                           </>
                        ) : (
                           priceData.price
                        )}
                     </Descriptions.Item>
                  </Descriptions>
               </div>
            </Col>
            <Col span={12}>
               <div style={col}>
                  <Descriptions size="small" contentStyle={{ color: "gray" }} column={2} title="Print">
                     <Descriptions.Item label="CMYK">{priceData.print.cmykColors}</Descriptions.Item>
                     <Descriptions.Item label="Pantone">{priceData.print.pantoneColors}</Descriptions.Item>
                     <Descriptions.Item label="White">{priceData.print.coveringWCount}</Descriptions.Item>
                     <Descriptions.Item label="Gold/Silver">{priceData.print.goldOrSilver}</Descriptions.Item>
                     <Descriptions.Item label="Varnish">{priceData.print.varnishType}</Descriptions.Item>
                     <Descriptions.Item label="Relief">{priceData.print.relief}</Descriptions.Item>
                     <Descriptions.Item label="Foil Count">{priceData.print.foilCount}</Descriptions.Item>
                     <Descriptions.Item label="Foil">{priceData.print.foilColor}</Descriptions.Item>
                  </Descriptions>
                  <Divider>
                     <Text style={{ fontSize: "12px", color: "gray" }}>Percent</Text>
                  </Divider>
                  {priceData.print.cmykColors > 0 ? (
                     <Row>
                        <Col span={8}>CMYK %</Col>
                        <Col flex="auto">
                           <Progress
                              strokeColor={{
                                 "0%": "#108ee9",
                                 "100%": "#87d068",
                              }}
                              format={(percent) => percent + `%`}
                              percent={Number.parseFloat(priceData.print.cmykPercent * 100).toFixed(0)}
                              size="small"
                           />
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
                  {priceData.print.pantoneColors > 0 ? (
                     <Row>
                        <Col span={8}>Pantone %</Col>
                        <Col flex="auto">
                           <Progress
                              strokeColor={{
                                 "0%": "#108ee9",
                                 "100%": "#87d068",
                              }}
                              format={(percent) => percent + `%`}
                              percent={Number.parseFloat(priceData.print.pantonePercent * 100).toFixed(0)}
                              size="small"
                           />
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
                  {priceData.print.coveringWCount > 0 ? (
                     <Row>
                        <Col span={8}>White %</Col>
                        <Col flex="auto">
                           <Progress
                              strokeColor={{
                                 "0%": "#108ee9",
                                 "100%": "#87d068",
                              }}
                              format={(percent) => percent + `%`}
                              percent={Number.parseFloat(priceData.print.coveringWPercent * 100).toFixed(0)}
                              size="small"
                           />
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
                  {priceData.print.goldOrSilver > 0 ? (
                     <Row>
                        <Col span={8}>Gold/Silver %</Col>
                        <Col flex="auto">
                           <Progress
                              strokeColor={{
                                 "0%": "#108ee9",
                                 "100%": "#87d068",
                              }}
                              format={(percent) => percent + `%`}
                              percent={Number.parseFloat(priceData.print.goldOrSilverPercent * 100).toFixed(0)}
                              size="small"
                           />
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
                  {priceData.print.varnishUse > 0 ? (
                     <Row>
                        <Col span={8}>Varnish %</Col>
                        <Col flex="auto">
                           <Progress
                              strokeColor={{
                                 "0%": "#108ee9",
                                 "100%": "#87d068",
                              }}
                              format={(percent) => percent + `%`}
                              percent={Number.parseFloat(priceData.print.varnishPercent * 100).toFixed(0)}
                              size="small"
                           />
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
                  {priceData.print.foilCount > 0 ? (
                     <Row>
                        <Col span={8}>Foil %</Col>
                        <Col flex="auto">
                           <Progress
                              strokeColor={{
                                 "0%": "#108ee9",
                                 "100%": "#87d068",
                              }}
                              format={(percent) => percent + `%`}
                              percent={Number.parseFloat(priceData.print.foilPercent * 100).toFixed(0)}
                              size="small"
                           />
                        </Col>
                     </Row>
                  ) : (
                     ""
                  )}
               </div>
            </Col>
            <Col span={6}>
               <div style={col}>
                  <Col span={24}>
                     <Text style={{ fontSize: "12px", color: "gray" }}>Dynamic Price</Text>
                  </Col>
                  <PriceDetailsTable tableData={priceData.dynamicPrice} />
               </div>
            </Col>
         </Row>
      </>
   );
}
